import { useSelector } from 'react-redux'

type UserRole = {
  role: string
  display: string
  description: string
  admin?: boolean
  order: number
}

const userRoles: UserRole[] = [
  // {
  //   role: 'Jyrney_Admin',
  //   display: 'Jyrney Admin',
  //   description: 'Administrator with full access',
  //   admin: true,
  //   order: 10,
  // },
  {
    role: 'Client_Admin',
    description: 'Full access to bookings and client management',
    display: 'Client Admin',
    order: 30,
  },
  {
    role: 'Traveller',
    description:
      'This account will be given a logon to the platform but can only book for themselves',
    display: 'Traveller',
    order: 60,
  },
  {
    role: 'Passenger',
    description:
      'This account will not have a logon to the platform but can be added to bookings',
    display: 'Passenger',
    order: 70,
  },
  {
    role: 'Travel_Consultant',
    display: 'Travel Consultant',
    description:
      'This account will be given a logon to the platform and can book for clients',
    order: 50,
  },
  {
    role: 'Senior_Travel_Consultant',
    display: 'Senior Travel Consultant',
    description:
      'This account will be given a logon to the platform and can book for clients',
    order: 40,
  },
  {
    role: 'Platform_Admin',
    display: 'Platform Admin',
    description:
      'Administrator with full access to the platform and all clients. Must also have Client Admin added to user.',
    order: 20,
    admin: true,
  },
]

const useUserRole = () => {
  const currentUser = useSelector((state: any) => state.users.user)

  const currentUserRoles =
    currentUser?.roles?.map((x: string) => {
      return x.toUpperCase()
    }) ?? []

  const validateAccess = (requiredRole: string) => {
    const targetRole = requiredRole.toUpperCase()
    return currentUserRoles.includes(targetRole)
  }

  const hasRole = (role: string[]) => {
    return role.some((item) => {
      const ucItem = item.toUpperCase()
      return currentUserRoles.includes(ucItem)
    })
  }

  const filteredRoles = (
    currentUserRoles?.includes('JYRNEY_ADMIN')
      ? [...userRoles]
      : userRoles.filter((role) => role.admin !== true)
  ).sort((a, b) => a.order - b.order)

  return {
    currentUserRoles,
    validateAccess,
    hasRole,
    filteredRoles,
  }
}

export default useUserRole
